module.exports = __webpack_public_path__ + "img/girl1.254d3ee1.jpg";